import React from "react";

export const Navbar = () => {
  return <div></div>;
};
